// type the gtag
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtag: any;
  }
}

export type GAEvent = {
  event_category: string;
  event_label: string;
  value: string;
};

export const sendCustomGAEvent = (eventType: string, eventData: GAEvent): void => {
  if (typeof window !== 'undefined' && window.gtag) {
    try {
      const hostname = window.location.hostname;
      const isProd = hostname === 'pennylane.ai';
      const finalEventType = isProd ? eventType : `${eventType}_test`;
      
      window.gtag('event', finalEventType, { ...eventData });
    } catch (err) {
      const eventInfo = {
        timestamp: new Date().toISOString(),
        eventType,
        eventData,
      };
      
      console.error('Error sending GA event', eventInfo, err);
    }
  }
};
